<template>
    <FormSearchSelect
        v-bind="$attrs"
        class="FormSelectMaterial"
        :value="value"
        :label="label"
        :options="materials"
        :reduce="material => material.id"
        :getOptionLabel="material => material.name"
        @input="handleInput"
    >
        <template v-if="showCreateOption" #list-header>
            <ButtonIcon icon="plus" class="block" @click="handleCreate">
                Add new
            </ButtonIcon>
        </template>
    </FormSearchSelect>
</template>

<script>
import { mapState } from 'vuex';
import MaterialCreateModal from '@/components/modals/MaterialCreateModal';

export default {
    name: 'FormSelectMaterial',
    inheritAttrs: false,

    props: {
        value: { type: Number },
        label: { type: String, default: 'Material' },
        showCreateOption: { type: Boolean, default: false },
    },

    computed: {
        ...mapState('company', ['materials']),
    },

    methods: {
        handleInput(materialId) {
            this.$emit('input', materialId);
        },

        handleCreate() {
            this.$analytics.trackButtonClick(this.$options.name, 'prompt_create_material', {
                model_type: 'material',
                model_action: 'create_intent',
            });

            this.$modal.show(MaterialCreateModal, {
                onMaterialCreated: this.handleMaterialCreated,
            });
        },

        handleMaterialCreated(newMaterial) {
            this.$emit('input', newMaterial.id);
        },
    },
};
</script>

<style lang="scss" scoped>
.FormSelectMaterial {
    .ButtonIcon {
        justify-content: flex-start;
    }
}
</style>
